module.exports = __webpack_public_path__ + "media/newstyle/images/logo-rakuten-46260f6a4ea5452562fc1fc0c7df08d7.png";